import React, { ReactElement } from 'react';

import { ModulesCard, ModulesGroups, useModules } from 'features/modules';
import { Col, Flex, Row, Typography, Section } from 'components';
import { ModulesInfoState } from 'features/modules';

interface ModulesListProps {
  modules: ModulesInfoState;
  productSlug: string;
}

const ModulesList = ({ modules, productSlug }: ModulesListProps): ReactElement => {
  // const { productSlug } = useParams();
  const { groups } = useModules();

  // TODO: permitir cadastro de hat e name nos módulos

  let modulesHat = 'Módulos do curso';
  let areasHat = 'Conheça as áreas de estudo do curso';

  if (productSlug === 'na-rota-do-mercado-financeiro' || productSlug === 'mentoria-estrategia-e-timing') {
    modulesHat = 'Módulos da mentoria';
    areasHat = 'Conheça as áreas de estudo da mentoria';
  }

  if (productSlug === 'clube-do-livro') {
    modulesHat = 'Clube do livro';
    areasHat = 'Conheça os livros que iremos estudar';
  }

  if (productSlug === 'fraternidade-melver') {
    modulesHat = 'Desenvolvimento intelectual';
    areasHat = 'Conheça os materiais de estudo';
  }

  return (
    <Flex bg={groups.length ? 'dark_350' : 'dark_150'} flexGrow={0} flexDirection="column">
      <Section pt={{ m: 30, t: 60, d: 90 }} flexDirection="column" flexGrow={0}>
        <Flex
          justifyContent="space-between"
          flexWrap={{ m: 'wrap', d: 'nowrap' }}
          alignItems="flex-end"
          flexGrow={0}
          data-testid="products-details-modules-section"
        >
          <Flex flexDirection="column" flexGrow={0}>
            <Typography type="type3" color="white25" upper>
              {modulesHat}
            </Typography>

            <Typography type="type8" fontWeight="bold" color="white" mt={2}>
              {areasHat}
            </Typography>
          </Flex>
        </Flex>

        <ModulesGroups productSlug={productSlug} />
      </Section>

      <Flex bg="dark_150" pt={{ m: 50 }} pb={{ m: 80 }}>
        <Section>
          {!!modules?.timelineCards.length ? (
            <Row gutter={30} flexGrow={0}>
              {modules?.timelineCards.map((productModule, index) => (
                <Col
                  key={index.toString()}
                  width={{ m: 1, t: 1 / 2, d: 1 / 4 }}
                  flexShrink={0}
                  flexGrow={0}
                  data-testid={`products-details-module-${index.toString()}`}
                >
                  <ModulesCard productModule={productModule} productClassUuid={modules?.productClassUuid} />
                </Col>
              ))}
            </Row>
          ) : (
            <Flex>
              <Typography type="type5" color="alert_400" fontWeight="bold">
                Nenhum módulo foi encontrado.
              </Typography>
            </Flex>
          )}
        </Section>
      </Flex>
    </Flex>
  );
};

export default ModulesList;
